// extracted by mini-css-extract-plugin
module.exports = {"container":"WashersTable_container__2mn0_","tableContainer":"WashersTable_tableContainer__39SkR"};